import { useQuery } from '@tanstack/react-query';
import { onboardingApiService } from '../services/onboardingApiService';
import type { UserOnboardingState } from '../types/onboarding';
import { useMemo } from 'react';

interface UseOnboardingReturn {
  isOnboardingStateLoading: boolean;
  onboardingState: UserOnboardingState | undefined;
  getOnboardingState: () => Promise<UserOnboardingState | undefined>;
  isCompleted: boolean;
  isEmailVerified: boolean;
  isTermsAccepted: boolean;
}

export const useOnboarding = (
  fetchOnboardingState: boolean = false
): UseOnboardingReturn => {
  const onboardingStateQuery = useQuery({
    queryKey: ['onboarding-state'],
    queryFn: () => onboardingApiService.getOnboardingStatus(),
    enabled: fetchOnboardingState,
  });

  const getOnboardingState = async () => {
    const result = await onboardingStateQuery.refetch();
    return result.data;
  };

  const isCompleted = useMemo(() => {
    return onboardingStateQuery.data?.isCnpCompleted ?? false;
  }, [onboardingStateQuery.data]);

  const isEmailVerified = useMemo(() => {
    return (
      (onboardingStateQuery.data?.isEmailCompleted &&
        onboardingStateQuery.data?.isEmailValidated) ??
      false
    );
  }, [onboardingStateQuery.data]);


    const isTermsAccepted = useMemo(() => {
    return (
      (onboardingStateQuery.data?.isBcTermsAccepted &&
        onboardingStateQuery.data?.isAnafTermsAccepted) ??
      false
    );
  }, [onboardingStateQuery.data]);

  return {
    onboardingState: onboardingStateQuery.data,
    isOnboardingStateLoading: onboardingStateQuery.isLoading,
    getOnboardingState,
    isCompleted,
    isEmailVerified,
    isTermsAccepted
  };
};
